
/* styles */
require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?sourceMap&-autoprefixer!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-ca1a3132!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./ClickFullscreen.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./ClickFullscreen.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-ca1a3132!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./ClickFullscreen.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./client/components/Misc/ClickFullscreen.vue
// module id = 125
// module chunks = 0